module.exports = __webpack_public_path__ + "img/payment-details.897e0683.svg";